<script>
  export let marginTop="140px";
  export let marginBottom="0px";
</script>


<div class="container" style="text-align:center;margin-top:{marginTop};margin-bottom:{marginBottom};">
    <div class="spinner-border text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
</div>